<template>
  <div class="reading">
    <div class="reading-title">{{ name }}</div>
    <div class="zy_constr">
      <Tabs :tabs="tabs" :currentTab="currentTab" @onClick="handleClick" />
      <swiper :options="swiperOptions" ref="mySwiper" class="reading-main">
        <swiper-slide v-for="(item, idx) in data" :key="item + idx">
          <div class="reading-desc">
            <p
              class="reading-desc__row"
              v-for="item in item.desc_wap"
              :key="item"
            >
              {{ item }}
            </p>
          </div>
          <img v-lazy="item.logo" alt="" class="reading-logo" />
          <div class="reading-link" v-if="item.download || item.web">
            <a v-if="item.download" :href="item.download" class="reading-link__btn">
              <img class="link-icon" v-lazy="'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/8d50dcd3-e14e-4c8e-97b8-327f9a998cfb.png'" alt="">
              <span class="link-text">下载App</span>
            </a>
            <a v-if="item.web" :href="item.web.url" class="reading-link__btn">
              <img class="link-icon" v-lazy="'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/74ba7bba-cd1e-49f8-bf2e-647575dee2ba.png'" alt="">
              <span class="link-text">{{ item.web.name_wap }}</span>
            </a>
          </div>
    
          <!-- 图片区域使用渐隐渐现效果 -->
          <div class="reading-img">
            <div :key="item.id" class="reading-img__wrapper">
              <img v-lazy="item.imgs_wap[0]" alt="" >
            </div>
          </div>
        </swiper-slide>
      </swiper>
        
    </div>
  </div>
</template>

<script>
import Tabs from "vue-tabs-with-active-line";

export default {
  name: "Application",
  components: {
    Tabs,
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    name: {
      type: String,
      default: ''
    }
  },
  data: function() {
    return {
      tabs: this.data.map(item => ({
        title: item.name,
        value: item.id
      })),
      currentTab: this.data[0].id,
      swiperOptions: {
        // 角度控制 - 通过touchAngle来控制手势角度
        // touchAngle: 15, // 允许的最大角度（度），超过这个角度的手势不会触发滑动
        // 高度自适应配置
        autoHeight: true, // 启用自动高度
        // 事件监听
        on: {
          slideChange: this.handleSlideChange
        }
      }
    };
  },
  computed: {
    /**
     * 获取Swiper实例
     * @returns {Object} Swiper实例
     */
    swiper() {
      return this.$refs.mySwiper ? this.$refs.mySwiper.swiper : null;
    }
  },
  mounted() {
    /**
     * 组件挂载后确保swiper正确初始化
     */
    this.$nextTick(() => {
      if (this.$refs.mySwiper && this.$refs.mySwiper.swiper) {
        // 确保初始状态正确
        this.$refs.mySwiper.swiper.update();
      }
    });
  },
  watch: {
    /**
     * 监听当前标签变化，同步swiper滑动位置
     */
    currentTab: {
      handler(newVal) {
        this.$nextTick(() => {
          const tabIndex = this.tabs.findIndex(tab => tab.value === newVal);
          if (tabIndex !== -1 && this.swiper) {
            this.swiper.slideTo(tabIndex);
          }
        });
      },
      immediate: false
    }
  },
  methods: {
    handleClick(value) {
      this.$nextTick(() => {
        this.currentTab = value;
      });
    },
    
    /**
     * 处理Swiper滑动切换事件
     * @param {Object} swiper - Swiper实例
     */
    handleSlideChange(swiper) {
      // 使用传入的swiper参数或computed属性
      const swiperInstance = swiper || this.swiper;
      
      // 添加安全检查
      if (!swiperInstance || typeof swiperInstance.activeIndex === 'undefined') {
        return;
      }
      
      const activeIndex = swiperInstance.activeIndex;
      if (this.tabs[activeIndex]) {
        this.currentTab = this.tabs[activeIndex].value;
      }
    }
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/variables.scss";
@import "@/styles/function.scss";

.zy_constr {
  text-align: center;
}
.reading-title {
  color: #000;
  text-align: center;
  padding: rem(72) 0 rem(52);
  font-size: rem(48);
  font-weight: 500;
}

.reading {
  overflow: hidden;
  box-sizing: border-box;
  margin-bottom: rem(36);
  background-color: rgba(248, 248, 250, 1);
}

.reading-main {
  text-align: center;
}

.reading-logo {
  height: rem(72);
  margin-top: rem(72);
  display: inline-block;
}

.reading-desc {
  margin-top: rem(48);
  text-align: left;
  padding: 0 rem(48);
  min-height: rem(54*3);
  &__row {
    font-size: rem(36);
    line-height: rem(54);
    color: rgba(0, 0, 0, 0.85);
  }
}

.reading-link {
  margin-top: rem(48);
  display: flex;
  justify-content: center;
}

.reading-img {
  margin-top: rem(72);
  height: rem(771);
  &__container {
    position: relative;
    width: 100%;
  }
  
  &__wrapper {
    width: 100%;
    
    img {
      display: block;
      width: 100%;
    }
  }
}


.reading-link__btn{
  position: relative;
  background: rgba(0, 0, 0, 0.05);
  padding: rem(24) rem(28*3) rem(24) rem(36);
  text-align: center;
  border-radius: rem(12);
  margin: 0 rem(18);
  .link-icon{
    width: rem(48);
    height: rem(48);
    vertical-align: rem(-9);
    margin-right: rem(12);
  }
  .link-text{
    font-size: rem(36);
    color: rgba(0, 0, 0, 0.85);
  }
  &::before,
  &::after {
    content: "";
    position: absolute;
    z-index: 1;
    right: rem(36);
    top: rem(50);
    width: rem(21);
    height: 1px;
    border-radius: 1px;
    background-color: rgba(0, 0, 0, 0.55);
    transition:all 0.3s ease;
    transform-origin: right center;
  }

  &::before {
    // top: 12px;
    // width: 8px;
    transform: rotate(45deg);
    
  }

  &::after {
    // bottom: 12px;
    transform: rotate(-45deg);
  }
}
::v-deep .swiper-slide{
  &-active {
    .reading-img{
      opacity: 1;
      transition: opacity 0.3s ease;
    }
  }
  &-next,
  &-prev {
    .reading-img{
      opacity: 0;
      transition: opacity 0.3s ease;
    }
  }
}

::v-deep .tabs {
  display: inline-flex;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    bottom: 1px;
    left: 0;
    height: 1px;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.1);
  }

  &__active-line {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 3px;
    background-color: $mainActive;
    transition: transform 0.4s ease, width 0.4s ease;
  }

  &__item {
    display: inline-block;
    margin-left: rem(72);
    padding: rem(15) 0;
    font-size: rem(42);
    color: rgba(0, 0, 0, 0.55);
    text-decoration: none;
    border: none;
    background-color: transparent;
    border-bottom: 2px solid transparent;
    cursor: pointer;
    transition: all 0.25s;
    @include disable-tap-highlight;
    &_active,
    &:hover {
      color: #000;
    }

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }
  }
}
/* Android 特定样式 */
@supports not (-webkit-touch-callout: none) {
    .S .reading-title {
      font-weight: bold;
    }
}
</style>
